module.exports = __webpack_public_path__ + "static/media/test7_3.9e1f4fc8.png";